import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import './InsightsDashboard.css';

const InsightsCard = ({ title, data, colors }) => {
  return (
    <div className="insights-card">
      <h3 className="card-title">{title}</h3>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="53.998%"
            innerRadius={50}
            outerRadius={80}
            paddingAngle={5}
            labelLine={false}
            activeIndex={null}
            activeShape={{ outerRadius: 90 }}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
>

            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend layout="vertical" align="right" verticalAlign="middle" />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default InsightsCard;
